import { create } from "zustand";
export const useAuth = create((set) => ({
    tokens: null,
    setTokens: (t) => set({ tokens: t }),
    clear: () => set({ tokens: null }),
}));
